import React from 'react';
import { BankAccount } from '../props';

interface DisplayFirstElementProps {
  items?: BankAccount[];
  renderComponent: React.ReactNode;
  fallbackComponent?: React.ReactNode;
}

const DisplayPayableBankAccountList: React.FC<DisplayFirstElementProps> = ({
  items,
  renderComponent,
}) => {
  if (items === undefined) {
    // Case 1: Array is undefined
    return null;
  }

  const hasFirstElement: boolean = items.length > 0;
  const firstElement = hasFirstElement ? items[0] : null;
  const isFirstElementValid: boolean =
    firstElement !== null &&
    firstElement !== undefined &&
    Object.keys(firstElement).length > 0;

  if (isFirstElementValid) {
    // Case 2: Array has the first element which is not empty
    return <div>{renderComponent}</div>;
  }

  // Case 3: Array has no elements or the first element is empty
  return null;
};

export default DisplayPayableBankAccountList;
